import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=3a2e6ed0&scoped=true&lang=html"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2e6ed0",
  null
  
)

export default component.exports